import { BannerCarousel } from '@bfa/common-ui';
import React from 'react';
import SubscribedCarouselSlide from './SubscribedCarouselSlide';
var SubscribedBannerSection = function (_a) {
    var slides = _a.slides;
    return (React.createElement("div", { "data-testid": "subscribed-landing-carousel" },
        React.createElement(BannerCarousel, { layout: "MOBILE" }, slides === null || slides === void 0 ? void 0 : slides.map(function (slide, index) { return (React.createElement(SubscribedCarouselSlide, { key: "subscribed-landing-carousel-slide-".concat(+index), slide: slide })); }))));
};
export default SubscribedBannerSection;
